import { useContext } from 'react';
import {
  TrackingServiceContext,
  type TrackingServiceContextState,
} from '../../context/trackingServiceContext';

export const useTrackingService = (): Partial<TrackingServiceContextState> =>
  useContext<Partial<TrackingServiceContextState>>(TrackingServiceContext);
